import React from "react";
import Button from "../Button/Button";
import "./SectionCard.css";

/**
 * Props:
 * - title: string
 * - description?: string
 * - icon?: ReactNode
 * - count?: number | string
 * - info?: ReactNode | string
 * - actions?: Array<{ label: string, onClick?: () => void, variant?: "primary"|"secondary"|"ghost", startIcon?: ReactNode, endIcon?: ReactNode }>
 * - accent?: string
 * - children?: ReactNode
 * - className?: string
 */
export default function SectionCard({
  title,
  description,
  icon,
  count,
  info,
  actions = [],
  accent = "#2f7d32",
  children,
  className = "",
  ...rest
}) {
  const titleId = React.useId();

  return (
    <section
      className={`section-card ${className}`}
      style={{ "--accent": accent }}
      aria-labelledby={titleId}
      {...rest}
    >
      <header className="section-card__header">
        <div className="section-card__title">
          {icon && <span className="section-card__icon">{icon}</span>}
          <h3 id={titleId} className="section-card__heading">{title}</h3>
        </div>

        {typeof count !== "undefined" && (
          <span
            className="section-card__count"
            aria-label="itens cadastrados"
            title="Itens cadastrados"
          >
            {count}
          </span>
        )}
      </header>

      {description && <p className="section-card__desc">{description}</p>}

      {typeof info !== "undefined" && info !== null && (
        <div className="section-card__info">{info}</div>
      )}

      {actions.length > 0 && (
        <div className="section-card__actions">
          {actions.map(({ label, onClick, variant = "primary", startIcon, endIcon }, i) => (
            <Button
              key={i}
              variant={variant}
              onClick={onClick}
              startIcon={startIcon}
              endIcon={endIcon}
            >
              {label}
            </Button>
          ))}
        </div>
      )}

      {children && <div className="section-card__body">{children}</div>}
    </section>
  );
}
